export default {
	name: 'servicesSection',
	title: 'Services Section',
	type: 'object',
	fields: [
		{
			name: 'title',
			title: 'Section Title',
			type: 'string',
		},
		{
			name: 'subtitle',
			title: 'Section Subtitle',
			type: 'text',
		},
		{
			name: 'services',
			title: 'Services',
			type: 'array',
			of: [
				{
					type: 'reference',
					to: [{ type: 'service' }],
				},
			],
		},
	],
};
